import { render, staticRenderFns } from "./PhoneCallRoundedButton.vue?vue&type=template&id=31f1023a&"
import script from "./PhoneCallRoundedButton.vue?vue&type=script&lang=js&"
export * from "./PhoneCallRoundedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports